"use client";

import { LegalLinks } from "oddsgate-ds";

type LegalLinkItemAttrs = {
  title?: string;
  linkType?: string;
  url?: string;
  fileUrl?: string;
  className?: string;
  style?: Record<string, unknown>;
  dropdown?: boolean;
  dropdownLinks?: {
    title?: string;
    linkType?: string;
    url?: string;
    fileUrl?: string;
  }[];
};

type LegalLinkItem = {
  blockName: string;
  attrs: LegalLinkItemAttrs;
  innerBlocks: any[];
};

export type IBlockLegalLinks = {
  attrs: {
    anchor?: string;
    variant?: string;
    className?: string;
    style?: Record<string, unknown>;
  };
  innerBlocks: LegalLinkItem[];
};

export default function BlockLegalLinks({ attrs, innerBlocks }: IBlockLegalLinks) {
  // Transform innerBlocks data to the format expected by LegalLinks component
  const links = innerBlocks.map(block => {
    const { attrs } = block;
    const { title, linkType, url, fileUrl, dropdown = true, dropdownLinks = [] } = attrs;
    
    // Determine the URL based on linkType
    const linkUrl = linkType === 'file' ? fileUrl : url;
    
    // Transform dropdownLinks to children if dropdown is true and has links
    const children = dropdown && dropdownLinks.length > 0 
      ? dropdownLinks.map(dropdownLink => ({
          label: dropdownLink.title || '',
          url: (dropdownLink.linkType === 'file' ? dropdownLink.fileUrl : dropdownLink.url) || ''
        }))
      : [];
    
    return {
      label: title || '',
      url: linkUrl || '',
      children
    };
  });

  return (
    <div className={attrs.className || ''} id={attrs.anchor || undefined}>
      <LegalLinks links={links} />
    </div>
  );
}